import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=1cc7ec1a&scoped=true&"
var script = {}
import style0 from "./Courses.vue?vue&type=style&index=0&id=1cc7ec1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7ec1a",
  null
  
)

export default component.exports